import { ContractRule } from "@/business/shared/commons/validator/validatorsTypes";

export class RequiredRule implements ContractRule {
  esValidationMessage: string;

  constructor(esValidationMessage: string) {
    this.esValidationMessage = esValidationMessage;
  }

  check(value: string, otherValue?: string): boolean {
    return value != null && value !== "";
  }
}
